module.exports = "pegasus_template/assets/background-patterns/small-crackle-bright.png";